import React from 'react';
import { Field } from 'redux-form';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import TextArea from '../../../content/components/TextArea/TextArea';
import { PublicCheckbox } from '../../../../common/components';
import {
  WhiteLabelContentContainer
} from '../WLContentContainer/WhiteLabelContentContainer';

const SalesBanner = ({ enabled }) => {

  return (
    <WhiteLabelContentContainer title={'Sales Banner'}>
      <>
        <Row>
          <Col sm={12}>
            <Field
              name={'meta.whitelabel.sales_banner.enabled'}
              component={PublicCheckbox}
              label={'Enabled'}
            />
          </Col>
        </Row>
        {enabled && (
          <>
            <Row>
              <Col sm={12}>
                <ControlLabel>Header</ControlLabel>
              </Col>
              <Col sm={12}>
                <Field
                  name="meta.whitelabel.sales_banner.sections.header_content"
                  component={TextArea}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <ControlLabel>Small Print</ControlLabel>
              </Col>
              <Col sm={12}>
                <Field
                  name="meta.whitelabel.sales_banner.sections.small_print"
                  component={TextArea}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <ControlLabel>Sub Header</ControlLabel>
              </Col>
              <Col sm={12}>
                <Field
                  name="meta.whitelabel.sales_banner.sections.sub_header_content"
                  component={TextArea}
                />
              </Col>
            </Row>
          </>
        )}
      </>
    </WhiteLabelContentContainer>
  );
};
export default SalesBanner;
